import { all, fork, takeLatest } from "redux-saga/effects";
import blobDownload from "shared-components-package/dist/hooks/blobDownload";
import CONSTANTS from "../CONSTANTS";
import { formatByIdSaga } from "src/store/helpers/formatByIdSaga";
import { toast } from "react-toastify";

const COMMON = "/services/common/";
export function* getFileData() {
  yield takeLatest(CONSTANTS.GET_MAIN_FILE_DATA, function* (action) {
    try {
      ////baseUrl needs change
      const url = `${COMMON}GetFileData?oid=${action.payload}`;

      yield blobDownload(url);
    } catch (e) {
      const message = yield formatByIdSaga("notifications.couldntGetInfo");
      toast.error(message);
    }
  });
}
export default function* commonSaga() {
  yield all([fork(getFileData)]);
}
